module.exports = __webpack_public_path__ + "img/login_acc_right.8df7293e.png";